import { render } from "./ManagerDesktopNav.vue?vue&type=template&id=54c69b63"
import script from "./ManagerDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ManagerDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script